import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';

import type { PropsWithChildren } from 'react';

import { LoadingPage } from './pages/loading';
import { Auth0WithoutPermission } from './pages/restricted';

export const AuthRequired = (props: PropsWithChildren) => {
  const { isAuthenticated, isLoading, error, loginWithRedirect } = useAuth0();

  useEffect(() => {
    if (!isAuthenticated && !isLoading && !error) {
      loginWithRedirect({
        appState: {
          returnTo: window.location.pathname,
        },
      });
    }
  }, [isAuthenticated, error, isLoading, loginWithRedirect]);

  if (isLoading || (!isAuthenticated && !isLoading && !error)) {
    return <LoadingPage />;
  }

  if (error) {
    return <Auth0WithoutPermission />;
  }

  return <>{props.children}</>;
};
